import React, { useState } from "react";
import ProgressBar from "../../../../components/ProgressBar";
import ImageUpload from "../comp/IDCapture";
import Header from "../../../Header/Header";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { showErrorToast } from "../../../utils";

export default function UploadCompanyOwnerDocuments() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState(null);

    // get data from previous page
    const { state } = useLocation();
    const handleNext = () => {
        if (!formData?.frontSide || !formData?.backSide) {
            showErrorToast("Upload both images!");
            return;
        }
        navigate("/company-verification/upload-documents", {
            state: {
                formData: {
                    ...state?.formData,
                    ...formData,
                },
            },
        });
    };
    return (
        <div className="tw-pt-[100px] tw-px-4 max-sm:tw-px-2">
            <Header title={"Upload Company Document"} />
            <ProgressBar currentStep={2} totalSteps={3} />
            <div className="tw-w-[80%] max-sm:tw-w-[95%] tw-mx-auto tw-p-6 max-sm:tw-p-4">
                <div className="tw-mb-6 max-sm:tw-mb-4">
                    <h1 className="tw-text-[20px] max-sm:tw-text-[18px] tw-font-semibold tw-text-black tw-mb-2 tw-border-dashed tw-text-center">
                        Upload Your Document
                    </h1>

                    <div className="tw-text-black tw-text-sm max-sm:tw-text-xs tw-mb-4 tw-leading-tight">
                        <p className="tw-mb-2">Instructions:</p>
                        <p className="tw-mb-1">• Please upload a clear image or scan of your selected document.</p>
                    </div>
                </div>

                <div className="tw-flex tw-flex-col lg:tw-flex-row tw-gap-4 max-sm:tw-gap-3">
                    <ImageUpload
                        formData={formData}
                        setFormData={setFormData}
                        label={"Front Side"}
                        completeLabel={"Choose Front of Document (Image)"}
                        name={"frontSide"}
                    />
                    <ImageUpload
                        formData={formData}
                        setFormData={setFormData}
                        completeLabel={"Choose Back of Document (Image)"}
                        label={"Back Side"}
                        name={"backSide"}
                    />
                </div>

                <p className="tw-text-red-500 tw-text-sm max-sm:tw-text-xs tw-mb-4 tw-w-full tw-text-end max-sm:tw-text-center">
                    *Ensure your Image format is PNG, JPG or JPEG
                </p>
                <div className="tw-w-full tw-flex tw-justify-center">
                    <button
                        onClick={handleNext}
                        className="tw-bg-primary tw-px-20 max-sm:tw-px-8 tw-text-white tw-py-2 max-sm:tw-py-3 tw-rounded-md hover:tw-bg-emerald-600 tw-transition-colors tw-w-full max-sm:tw-max-w-xs tw-font-medium"
                    >
                        Next
                    </button>
                </div>
            </div>
        </div>
    );
}
